<template>
  <div  class="error-alert-container">
    <div class="error-alert-wrapper">
      <icon name="mdi:error" class="mt-2"/>

      <div class="d-flex flex-column fill-width">
        <p class="ma-0">{{ errorPt.errors[error.id]?.title }}</p>
        <p class="ma-0">{{ errorPt.errors[error.id]?.message }}</p>
        <span v-if="totalErrors > 1">
          {{ totalErrors }} restantes
        </span>
      </div>

      <base-button-text
        class="pa-0 close mt-2"
        title="Fechar Alerta"
        @click="() => store.REMOVE_ERROR(error)"
      >
        <icon
          name="mdi:close"
          class="close-icon"
          style="color: var(--main-primary);"
        />
      </base-button-text>
    </div>
  </div>
</template>

<script lang="ts" setup>
import errorPt from '../../i18n/errors/pt'

const props = defineProps<{
  error: {
    id: keyof typeof errorPt.errors;
  };
  totalErrors: number;
}>();

const store = errorStore()

onMounted(() => {
  setTimeout(() => {
    store.REMOVE_ERROR(props.error)
  }, 5000);
});
</script>

<style lang="scss" scoped>
.error-alert-container {
  position: fixed;
  bottom: 24px;
  left: 24px;
  min-width: 320px;
  max-width: 380px;
  padding: 18px 24px 18px 18px;
  z-index: 9999;
  background: linear-gradient(90deg, #ffebee 60%, #ffcdd2 100%);
  border-radius: 12px;
  color: #b71c1c;
  box-shadow: 0 4px 24px 0 rgba(0,0,0,0.10), 0 1.5px 4px 0 rgba(0,0,0,0.08);
  border: 1.5px solid #ffcdd2;
  font-family: 'Inter', Arial, sans-serif;
  transition: box-shadow 0.2s;
}

.error-alert-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
}

.error-alert-wrapper .icon {
  font-size: 2rem;
  color: #d32f2f;
}

.error-alert-wrapper p {
  font-size: 1.05rem;
  font-weight: 600;
  color: #b71c1c;
  margin-bottom: 2px;
  line-height: 1.3;
}

.error-alert-wrapper p + p {
  font-size: 0.98rem;
  font-weight: 400;
  color: #b71c1c;
  margin-top: 0;
  opacity: 0.85;
}

.error-alert-wrapper span {
  font-size: 0.92rem;
  color: #b71c1c;
  opacity: 0.7;
}

.close {
  margin-left: auto;
  background: none;
  border: none;
  box-shadow: none;
  cursor: pointer;
  align-self: flex-start;
  padding: 0;
}

.close-icon {
  font-size: 1.3rem;
  color: #d32f2f !important;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.close-icon:hover {
  opacity: 1;
}
</style>
